var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"disable-sort":"","disable-pagination":"","hide-default-footer":"","items-per-page":100,"mobile-breakpoint":0,"headers":_vm.tableHeaders,"items":_vm.data},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var headers = ref.headers;
return [_c('tr',_vm._l((headers),function(header,index){return _c('td',{key:index,class:_vm.getColumnClasses(header, item)},[_vm._v(" "+_vm._s(item[header.value])+" ")])}),0)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }